import { render, staticRenderFns } from "./DataTablePeriodic.vue?vue&type=template&id=79f90b7a&scoped=true"
import script from "./DataTablePeriodic.vue?vue&type=script&lang=js"
export * from "./DataTablePeriodic.vue?vue&type=script&lang=js"
import style0 from "./DataTablePeriodic.vue?vue&type=style&index=0&id=79f90b7a&prod&lang=scss&scoped=true"
import style1 from "./DataTablePeriodic.vue?vue&type=style&index=1&id=79f90b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f90b7a",
  null
  
)

export default component.exports